import { useGiggedApiSWR } from "./common/giggedApiSWR";
import { ApiTalentDashboardDto } from "../models/api/talentDashboard";
import { mapFromApiTalentDashboard } from "../models/mappers/talentDashboard";

export const useTalentDashboard = () => {
    const url = "api/me/talent-dashboard";

    const apiCall = useGiggedApiSWR<ApiTalentDashboardDto>(url);

    return {
        dashboardData: apiCall.data ? mapFromApiTalentDashboard(apiCall.data) : undefined,
        isLoading: apiCall.isLoading,
    };
};
